import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { FilterGeneratorProps } from '..';
import { useTranslateWithStringArgs } from 'src/ui/hooks/use-translate';
import { useMultiSelectSearch } from '../../hooks';
import FilterMultiSelect from '../../filter-popup/filter-multi-select';
import FilterMultiGroupOption from '../../filter-popup/filter-multi-group-option';

export const FilterGeneratorText = <Data,>(
  props: PropsWithChildren<FilterGeneratorProps<Data>>,
): ReactElement | null => {
  const {
    cellData: { getFilterData, searchFieldName, processFilterData, title, filterName = '' },
  } = props;

  const [showMultiSelect, setShowMultiSelect] = useState(false);

  const translate = useTranslateWithStringArgs();

  const { dataFilter, onSearch, hasSearchQuery, loading } = useMultiSelectSearch({
    apiFetch: getFilterData,
    searchFieldName,
    processFilterData,
  });

  useEffect(() => {
    if (dataFilter && !hasSearchQuery) {
      setShowMultiSelect(dataFilter?.length > 3 || dataFilter?.length === 0);
    }
  }, [dataFilter, hasSearchQuery]);

  const renderInputFilter = () => {
    return showMultiSelect ? (
      <FilterMultiSelect
        label={title}
        placeholder={translate('filters.multiselect.placeholder')}
        options={dataFilter}
        input={filterName}
        defaultField={filterName}
        onSearch={onSearch}
        loading={loading}
      />
    ) : (
      <FilterMultiGroupOption
        input={filterName}
        defaultField={filterName}
        label={title}
        options={dataFilter.map((filterOption) => ({ ...filterOption, value: [filterOption.value] }))}
      />
    );
  };

  return renderInputFilter();
};
